import styled from 'styled-components';

import LocateIcon from '../../Icons/Locate';

import { CommonPropsButtons } from '../styles';

export const StyledLocateIcon = styled(LocateIcon)`
  ${CommonPropsButtons}
`;
